import { Row } from "@tanstack/react-table";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { format, isSameDay } from "date-fns";
import Cookies from "js-cookie";

import { Employee } from "../schema";
import { getEmployeeCheckinsQueryOptions } from "@/config/queries/query-options";
import { Badge } from "@/components/ui/badge/badge";
import { Skeleton } from "@/components/ui/skeleton/skeleton";

interface DataTableRowActionsProps {
  row: Row<Employee>;
}

export function EmployeeMarking({ row }: DataTableRowActionsProps) {
  const key = Cookies.get("key") as string;

  const { data, isPending } = useQuery(
    getEmployeeCheckinsQueryOptions(key, row?.original?.id)
  );

  const todayCheckin = useMemo(() => {
    if (isPending) {
      return null;
    }

    if (data === undefined || data?.checkins === undefined) {
      return null;
    }

    const foundToday = data?.checkins?.find((item) => {
      const todayDate = new Date();
      const givenDate = new Date(item?.createdAt);

      const areEqual = isSameDay(todayDate, givenDate);

      return areEqual && item?.mode === "IN";
    });

    if (!foundToday) return null;

    return foundToday;
  }, [isPending, data]);

  if (isPending) {
    return (
      <>
        <Skeleton className="w-20 h-5 rounded-lg" />
      </>
    );
  }

  return (
    <>
      {todayCheckin ? (
        <div className="flex flex-col gap-1">
          <Badge className="self-start bg-emerald-400">Present</Badge>
          <div className="text-xs">
            IN - {format(todayCheckin?.createdAt, "p")}
          </div>
        </div>
      ) : (
        <div>
          <Badge className="self-start bg-red-400">Absent</Badge>
        </div>
      )}
    </>
  );
}
